import React, { useState } from 'react';
import { TacticalLabel } from './TacticalLabel';
import { Star, Link as LinkIcon, ChevronLeft, ChevronRight } from 'lucide-react';
const testimonials = [{
  id: 1,
  quote: "Sapper showed up when the other guys didn't. Diagnosed a bad capacitor in 10 minutes, had us cooling again before sundown. They earned a customer for life.",
  name: 'Mark R.',
  city: 'Gilbert',
  service: 'AC Repair',
  date: 'May 2026'
}, {
  id: 2,
  quote: 'Got three estimates for a full system replacement. Sapper beat the lowest by $400 and threw in a 10-year warranty. Crew was clean, fast, and respectful.',
  name: 'Jennifer L.',
  city: 'Chandler',
  service: 'AC Replacement',
  date: 'Apr 2026'
}, {
  id: 3,
  quote: 'Installed a Daikin mini-split in my garage gym. Cools 110° down to 72° in 20 minutes. These guys know their stuff.',
  name: 'Kyle M.',
  city: 'Scottsdale',
  service: 'Mini-Split Install',
  date: 'Mar 2026'
}];
export function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);
  const next = () => setActiveIndex(current => (current + 1) % testimonials.length);
  const prev = () => setActiveIndex(current => (current - 1 + testimonials.length) % testimonials.length);
  return <section id="reviews" className="py-24 bg-[#141A15] relative" data-id="element-337">
      <div className="container mx-auto px-4 sm:px-6" data-id="element-338">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6" data-id="element-339">
          <div data-id="element-340">
            <TacticalLabel className="mb-4" data-id="element-341">
              FIELD REPORTS // VERIFIED
            </TacticalLabel>
            <h2 className="font-condensed font-bold text-5xl sm:text-6xl text-sapper-white uppercase tracking-tight" data-id="element-342">
              WHAT OUR CUSTOMERS SAY
            </h2>
          </div>
          <div className="flex gap-2" data-id="element-343">
            <button onClick={prev} className="p-3 border border-sapper-olive/50 text-sapper-white hover:bg-sapper-olive/20 transition-colors" data-id="element-344">
              <ChevronLeft className="w-6 h-6" data-id="element-345" />
            </button>
            <button onClick={next} className="p-3 border border-sapper-olive/50 text-sapper-white hover:bg-sapper-olive/20 transition-colors" data-id="element-346">
              <ChevronRight className="w-6 h-6" data-id="element-347" />
            </button>
          </div>
        </div>

        {/* Desktop Grid */}
        <div className="hidden md:grid grid-cols-3 gap-6 mb-16" data-id="element-348">
          {testimonials.map(t => <TestimonialCard key={t.id} testimonial={t} data-id="element-349" />)}
        </div>

        {/* Mobile Carousel */}
        <div className="md:hidden mb-16 relative overflow-hidden" data-id="element-350">
          <div className="flex transition-transform duration-300 ease-in-out" style={{
          transform: `translateX(-${activeIndex * 100}%)`
        }} data-id="element-351">
            {testimonials.map(t => <div key={t.id} className="w-full flex-shrink-0 px-2" data-id="element-352">
                <TestimonialCard testimonial={t} data-id="element-353" />
              </div>)}
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center gap-8 sm:gap-16 pt-12 border-t border-sapper-olive/30" data-id="element-354">
          <div className="font-condensed font-bold text-xl text-sapper-gray uppercase flex items-center gap-2" data-id="element-355">
            <Star className="w-5 h-5 text-sapper-khaki fill-sapper-khaki" data-id="element-356" />{' '}
            Google 5-Star
          </div>
          <div className="font-condensed font-bold text-xl text-sapper-gray uppercase" data-id="element-357">
            BBB A+ Rated
          </div>
          <div className="font-condensed font-bold text-xl text-sapper-gray uppercase" data-id="element-358">
            Veteran-Owned
          </div>
          <div className="font-condensed font-bold text-xl text-sapper-gray uppercase" data-id="element-359">
            ROC #345678
          </div>
        </div>
      </div>
    </section>;
}
function TestimonialCard({
  testimonial
}: {
  testimonial: any;
}) {
  return <div className="bg-sapper-dark border-2 border-sapper-olive/30 p-8 relative rounded-sm h-full flex flex-col" data-id="element-360">
      {/* Dog Tag Chain Accent */}
      <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#141A15] px-2" data-id="element-361">
        <LinkIcon className="w-5 h-5 text-sapper-gray" data-id="element-362" />
      </div>

      <div className="flex gap-1 mb-6 mt-2" data-id="element-363">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-sapper-khaki fill-sapper-khaki" data-id="element-364" />)}
      </div>

      <p className="font-sans text-sapper-white/90 text-lg italic mb-8 flex-grow" data-id="element-365">
        "{testimonial.quote}"
      </p>

      <div className="border-t border-sapper-olive/30 pt-4 mt-auto" data-id="element-366">
        <div className="font-condensed font-bold text-lg text-sapper-white uppercase" data-id="element-367">
          {testimonial.name}
        </div>
        <div className="font-mono text-xs text-sapper-gray tracking-wider mt-1" data-id="element-368">
          {testimonial.city} // {testimonial.service} // {testimonial.date}
          // {testimonial.service} // {testimonial.date}
          // {testimonial.date}
        </div>
      </div>
    </div>;
}